import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { CommonLocalizationService } from './Services/common-localization.service';
import { CheckInDataService } from './Services/check-in-data.service';
import { applicationPaths, localStorageKeys } from './Models/configurations';
import { CustomerDropOffLog } from './Models/CustomerDropOffLogModel';
import { SecureStorageService } from './Services/secure-storage.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Check In';
  public showServiceUnavailableBanner = false;
  currentRoute:string = '';
  routeModel:CustomerDropOffLog
  constructor(
    private readonly titleService: Title,
    private readonly translate: TranslateService,
    private readonly cookieService: CookieService,
    private readonly router: Router,
    private readonly commonLocalizationService: CommonLocalizationService,
    private readonly checkInDataService: CheckInDataService,
    private readonly secureStorageService: SecureStorageService,
    private readonly currentLanguageService: CurrentLanguage,    
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
          // Hide progress spinner or progress bar
          this.currentRoute = event.url;          
          let route = this.currentRoute.replace('/','');
          this.routeModel = {
            routeName:route
          }
          if(applicationPaths.login == route || applicationPaths.first == route|| applicationPaths.second == route || applicationPaths.third == route
            || applicationPaths.fourth == route || applicationPaths.five == route || applicationPaths.six == route || applicationPaths.seven == route || applicationPaths.calldealer == route
            ||  applicationPaths.unauthorize == route || applicationPaths.confirmationfail == route || applicationPaths.cookiePolicy == route)
            {
              let isCheckInCompleted = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).checkInStatus;
              if(isCheckInCompleted){
                this.routeModel = {
                  routeName:'re-checkIn'
                }
              }
              this.checkInDataService.StoreRouteTraversalLog(this.routeModel);
            }
      }
    })
  }

  public bannerClosed(): void {
    this.showServiceUnavailableBanner = true;
  }

  ngOnInit(): void {
    this.cookieService.delete('userSelectedLanguage')
    if (this.isCookiesExist()) {
      this.translate.use(this.cookieService.get('userSelectedLanguage'));
      this.currentLanguageService.currentLanguage.next(this.cookieService.get('userSelectedLanguage'));
    } else if (EnvSetting.language.LanguageOverRule) {
      this.translate.setDefaultLang(EnvSetting.language.LanguageOverRuleDefault);
      this.translate.use(EnvSetting.language.LanguageOverRuleDefault);
      this.currentLanguageService.currentLanguage.next(EnvSetting.language.LanguageOverRuleDefault);
    }
    else {
      let currentLang = this.commonLocalizationService.customerDefaultLanguage ?? EnvSetting.CHECKIN_DEFAULT_LANGUAGE_CONFIG;
      this.translate.setDefaultLang(currentLang);
      this.translate.use(currentLang);
      this.currentLanguageService.currentLanguage.next(currentLang);
    }
    this.titleService.setTitle(this.title);
    if (sessionStorage.getItem('showBanner') !== null) {
      this.showServiceUnavailableBanner = true;
    } else {
      this.showServiceUnavailableBanner = false;
    }
    if(localStorage.getItem('showBanner') == 'false')
    {
      this.showServiceUnavailableBanner = true;
    }
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
      return;
      }
      window.scrollTo(0, 0)
      });
  }

  private isCookiesExist(): boolean {
    return this.cookieService.check('userSelectedLanguage');
  }
}
